import styled from 'styled-components';
import { Badge as AntBadge } from 'antd';
import { colors } from '@10d/tend-ui-tokens/samolet';

const BadgeStatusColors = {
  default: colors.gray400,
  success: colors.green600,
  warning: colors.gold600,
  processing: colors.blue600,
  error: colors.red600,
};

export const Badge = styled(AntBadge)`
  display: inline-flex;
  align-items: center;
  flex-direction: ${props => (props.count ? 'row-reverse' : 'row')};
  gap: 8px;

  .ant-scroll-number-only,
  .ant-scroll-number-only-unit {
    display: inherit;
    height: 12px;
    align-items: inherit;
  }

  .ant-badge-count {
    box-shadow: none;
    display: flex;
    align-items: center;
    min-width: 16px;
    height: 16px;
    padding: 0px 5px;
    line-height: 16px;
    background: ${colors.red600};
    border-radius: 32px;
  }

  .ant-badge-status-text {
    color: ${colors.gray900};
    line-height: 24px;
    margin-left: 0px;

    &:empty {
      display: none;
    }
  }

  .ant-badge-status-dot {
    top: 0;
    width: 8px;
    height: 8px;
    background-color: ${({ status = 'default' }) => BadgeStatusColors[status]};
  }

  &.ant-badge-not-a-wrapper:not(.ant-badge-status) {
    vertical-align: initial;
  }
`;
